export default [
  {
    id: "sidebar-company",
    label: "Companies",
    link: "/company/",
    suffix: "New",
    stocks: true,
  },
  {
    id: "sidebar-btc-production",
    label: "BTC Production",
    link: "/btc-production/",
    suffix: "New",
    stocks: true,
  },
  {
    id: "sidebar-btc-hodl-position",
    label: "BTC HODL Position",
    link: "/btc-hodl-position/",
    suffix: "New",
    stocks: true,
  },
  {
    id: "sidebar-hashrate",
    label: "Hashrate",
    link: "/hashrate/",
    suffix: "New",
    stocks: true,
  },
  {
    id: "sidebar-market-cap",
    label: "Market Cap",
    suffix: "Soon",
  },
  {
    id: "sidebar-number-of-shares",
    label: "Number of Shares",
    suffix: "Soon",
  },
]
